export default "__VITE_ASSET__QdUrwqXk__"